// Dependencies
import Slider from 'modules/slider';


class HeroSlider extends Slider {
  /**
   * Constructor: Hero Slider Constructor.
   */
  constructor(options = {}) {
    // Inherit constructor.
    super(options);

    if (!this._root || this._nodes.length === 0) {
      return;
    }
    
    // Elements
    this._pages = options.pages;

    // Attributes
    this._prevPage    = null;
    this._currentPage = null;

    // Events
    this._pages.map((page, i) => {
      page.addEventListener('click', this.to.bind(this, i));
    });

    // Init
    this.change(this._index, false);
  }


  /**
   * Change: Deactivate current node and activate selected one.
   *
   * @param {Int} index - Selected index.
   */
  change(index, running = true) {
    // Inherit `change` method.
    super.change(index, running);

    // Update the prev and current nodes.
    this._prevPage    = this._currentPage;
    this._currentPage = this._pages[this._index];

    // Toggle previous node and current one.
    if (this._prevPage) {
      this._prevPage.classList.remove('is-active');
    }

    if (this._currentPage) {
      this._currentPage.classList.add('is-active');
    }

    // Transitions
    if (running && window.innerWidth >= 780) {
      this.tOut();
      this.tIn();
    } else {
      // Update attributes
      this._running = false;
    }
  }


  /**
   * TOut: Transition `Out` of the previous node.
   * 
   * @param {Function} callback - Callback method.
   */
  tOut(callback = null) {
    if (!this._prev) {
      return;
    }

    // Elements
    const mask    = this._prev.querySelector('.card__picture-mask');
    const inner   = this._prev.querySelector('.card__content-inner');
    const content = this._prev.querySelector('.card__content');

    // Classnames
    this._prev.classList.remove('is-active');
    this._prev.classList.add('is-inactive');

    // Complete Method
    const complete = () => {
      // Reset Classnames
      this._prev.classList.remove('is-inactive');

      // Clean Elements
      TweenMax.set(mask, { clearProps: 'all' });
      TweenMax.set(inner, { clearProps: 'all' });

      // Callback
      if (callback) {
        callback();
      }
    };

    // Transition Mask
    TweenMax.fromTo(mask, 0.6, {
      scaleX: 0,
      scaleY: 1,
    }, {
      scaleX: 1,
      scaleY: 1,
      ease: Quart.easeOut,
      onComplete: complete,
    });

    // Transition Content Inner
    TweenMax.fromTo(inner, 0.3, {
      alpha: 1,
    }, {
      alpha: 0,
      ease: Quad.easeOut,
    });
  }


  /**
   * TIn: Transition `In` of the previous node.
   * 
   * @param {Function} callback - Callback method.
   */
  tIn(callback = null) {
    if (!this._current) {
      return;
    }

    // Elements
    const mask    = this._current.querySelector('.card__picture-mask');
    const inner   = this._current.querySelector('.card__content-inner');
    const content = this._current.querySelector('.card__content');

    // Classnames
    this._current.classList.remove('is-inactive');
    this._current.classList.add('is-active');

    // Complete Method
    const complete = () => {
      // Update attributes
      this._running = false;

      // Clean Elements
      TweenMax.set(mask, { clearProps: 'all' });
      TweenMax.set(inner, { clearProps: 'all' });

      // Callback
      if (callback) {
        callback();
      }
    };

    // Toggle Content
    TweenMax.set(content, {
      alpha: 0,
    });

    TweenMax.set(content, {
      alpha: 1,
      delay: 0.6,
    });

    // Transition Mask
    TweenMax.fromTo(mask, 0.6, {
      scaleX: 1,
      scaleY: 1,
    }, {
      scaleX: 0,
      scaleY: 1,
      delay: 0.6,
      ease: Quart.easeOut,
      onComplete: complete,
    });

    // Transition Content Inner
    TweenMax.fromTo(inner, 0.3, {
      alpha: 0,
    }, {
      alpha: 1,
      delay: 0.6,
      ease: Quad.easeOut,
    });
  }
}

export default HeroSlider;


// WEBPACK FOOTER //
// ./src/js/layouts/hero/slider.js